import { type SlotsToClasses } from "@heroui/react";
import clsx from "clsx";
import { PageTitle, type PageTitleProps } from "./PageTitle";

export interface PageContainerProps extends Omit<PageTitleProps, 'className'> {
    children?: React.ReactNode;
    visibleTitle?: boolean;
    classNames?: SlotsToClasses<"title" | "main">;
}

export const PageContainer: React.FC<PageContainerProps> = ({
    classNames,
    children,
    visibleTitle = true,
    ...pageTitleProps
}) => {

    return (
        <>
            {visibleTitle && <PageTitle className={clsx(classNames?.title)} {...pageTitleProps} />}
            <main className={clsx("max-w-full min-w-0", classNames?.main)}>
                {children}
            </main>
        </>
    )
}